import { render, staticRenderFns } from "./MaterialStage.vue?vue&type=template&id=11a80d06"
import script from "./MaterialStage.vue?vue&type=script&lang=js"
export * from "./MaterialStage.vue?vue&type=script&lang=js"
import style0 from "./MaterialStage.vue?vue&type=style&index=0&id=11a80d06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports